import React from 'react';
import PropTypes from 'prop-types';

import ReviewHighlight from 'Components/Account/AccountOverview/AccountHighlights/ReviewHighlight';
import WishlistHighlight from 'Components/Account/AccountOverview/AccountHighlights/WishlistHighlight';

import 'Components/Account/AccountOverview/AccountHighlights/AccountHighlights.scss';

export default function AccountHighlights({ wishlistNumber, reviews }) {
  return (
    <div className="account-highlights-container">
      <div className="account-highlights-column">
        <WishlistHighlight wishlistNumber={wishlistNumber} />
      </div>
      <div className="account-highlights-column">
        <ReviewHighlight reviews={reviews} />
      </div>
    </div>
  );
}

AccountHighlights.propTypes = {
  wishlistNumber: PropTypes.number,
  reviews: PropTypes.arrayOf(PropTypes.object),
};

AccountHighlights.defaultProps = {
  wishlistNumber: 0,
  reviews: [],
};
